import * as React from 'react';
export var Tick = function Tick(_a) {
  var className = _a.className;
  return React.createElement("svg", {
    className: className,
    width: "16",
    height: "16",
    viewBox: "0 0 48 48"
  }, React.createElement("g", null, React.createElement("g", null, React.createElement("polygon", {
    points: "15,39 18,42 48,12 42,6 18,30 6,18 0,24 12,36"
  }))));
};